import { render, staticRenderFns } from "./PromptPage.vue?vue&type=template&id=1c72a553&scoped=true"
import script from "./PromptPage.vue?vue&type=script&lang=js"
export * from "./PromptPage.vue?vue&type=script&lang=js"
import style0 from "./PromptPage.vue?vue&type=style&index=0&id=1c72a553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72a553",
  null
  
)

export default component.exports